import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

const className = "deersteakmeat";

function GIDeerSteakMeat() {
  return (
    <ItemPresenter imagePath={`/images/gameItems/${className}.png`} tooltipText={className} />
  );
}

export default GIDeerSteakMeat;